<template lang="html">
  <div class="contact-teaser">
    <div
      :class="[`contact-teaser__content--${focusClass}`]"
      class="contact-teaser__content"
    >
      <span v-editable="resource.columns.title" class="contact-teaser__title" />
      <Wysiwyg
        v-if="resource.columns.text"
        class="contact-teaser__text"
      >
        <div v-editable="resource.columns.text" />
      </Wysiwyg>
      <div v-if="resource.teamMember" class="contact-teaser__container">
        <span class="contact-teaser__name">
          <AppLink
            :is-link="resource.teamMember && resource.teamMember.url"
            :to="resource.teamMember.url"
          >
            {{ resource.teamMember.readableName }}
          </AppLink>
        </span>
        <span
          v-if="resource.teamMember.columns.email"
          class="contact-teaser__email"
        >
          <a :href="'mailto:'+resource.teamMember.columns.email">
            {{ resource.teamMember.columns.email }}
          </a>
        </span>
      </div>
    </div>
    <Media
      v-if="resource.teamMember && resource.teamMember.columns.teaserAsset"
      :path="resource.teamMember.columns.teaserAsset"
      class="contact-teaser__image"
    />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/elements/media'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import AppLink from 'beisheim/components/elements/app-link'
import { Resource } from 'beisheim/models'

export default {
  components: {
    Media,
    Wysiwyg,
    AppLink
  },
  mixins: [ editable ],
  computed: {
    parent () {
      return Resource.find(this.resource.parent_id)
    },
    focusClass () {
      if (!this.parent || !this.parent.columns) {
        return ''
      }
      if (this.parent.resource_class_name === 'Project' && this.parent.columns.focus) {
        return this.parent.columns.focus.toLowerCase()
      }
      if (this.parent.resource_class_name === 'FocusPage' && this.parent.columns.title) {
        return this.parent.columns.title.toLowerCase()
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/colors';
@import '~beisheim/scss/scale';
@import '~beisheim/scss/zindex';
@import '~beisheim/scss/font';
@import '~beisheim/scss/grid';
@import '~beisheim/scss/breakpoints';

.contact-teaser {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;

  @include from(4) {
    flex-direction: row;
  }

  &__content {
    display: flex;
    flex-direction: column;
    background-color: #00B0B1;
    position: relative;
    @include grid-spacing(padding-top, 4);
    @include grid-spacing(padding-bottom, 4);
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);

    @include from(4) {
      @include grid-spacing(padding-top, 2);
      @include grid-spacing(padding-bottom, 2);
      width: 50%;
    }

    &--kultur { background-color: brand(1); }
    &--sport { background-color: brand(2); }
    &--bildung { background-color: brand(3); }
    &--gesundheit { background-color: brand(4); }
  }

  &__container {
    @include from(4) {
      margin-top: auto;
    }
  }

  &__title {
    @include font(2);
    display: block;
    max-width: 480px;
    margin-bottom: scale(5);

    @include from(5) {
      @include font(3);
    }
  }

  &__text {
    display: block;
    max-width: 480px;
    margin-bottom: scale(5);
    @include font(0.5);
  }

  &__name {
    display: block;
    margin-bottom: scale(2);
    @include font(1);
  }

  &__email {
    display: block;
    @include font(0);
    a {
      text-decoration: underline;
    }
  }

  &__image {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    max-height: 720px;

    @include from(4) {
      width: 50%;
    }

    img {
      transition: transform 400ms cubic-bezier(.24,0,.47,1);
    }

    img:hover {
      transform: scaleX(1.1) scaleY(1.1);
    }
  }
}
</style>
